<section class="page__header">
    <custom-app-bar
            [hasBackButton]="true"
            [title]="'change_delivery_point.title' | translate"
    ></custom-app-bar>
</section>
<section class="page__content">
    <ep-delivery-points
            [askToChangeDeliveryPoint]="true"
    ></ep-delivery-points>
</section>


